import axios from "axios";

const obtenerProducto = async (id) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/productos/${id}`,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export {
    obtenerProducto
}